
import { Request } from '../../../../index'
import { ParamsPOST } from 'app/common/types/food/schools/complexes/copySort'


type ParamsAPI = {
  to_school_ids: Array<number>
}

type UrlParams = {
  id: number | string,
}

export const convertParams = (params: ParamsPOST): [ParamsAPI, UrlParams] => {
  const orgs = params.toOrgIds.map(org => (parseInt(org, 10)))
  return ([{ to_school_ids: orgs }, { id: params.orgId }])
}

export const convertResult = (result: string) => {
  return result === 'success'
}

export const POST_COMPLEXES_COPY_SORT: Request<ParamsPOST, ParamsAPI, UrlParams> = [
  'food/schools/{id}/complexes/copy_sort',
  'post',
  ['data'],
]
